import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../../core/pagination/datatable.jsx";
import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_GET_MY_TEAM,
} from "../../RollCallConfig/RollCallConfig.js";
import { Spin } from "antd";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RotateCcw } from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../../core/img/imagewithbasebath";
import CommonFooter from "../../../../../core/common/footer/commonFooter.jsx";

const TeamMembers = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();

  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const regId = userData?.RegId;

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    const isManager = sessionStorage.getItem("isManager");

    if (isManager === "false") {
      alert("You don't have access to this page.");
      sessionStorage.clear();
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);
  console.log(teamMembers);

  useEffect(() => {
    setloading(true);

    if (tokenData && superIdData) {
      fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_GET_MY_TEAM}?managerid=${regId}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        }
      )
        .then((response) => {
          console.log(response);
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.status) {
            setTeamMembers(data.ResultData || []);
          } else {
            console.error("Invalid data format:", data);
            setTeamMembers([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setloading(false);
        });
    }
  }, [superIdData, tokenData]);

  const columns = [
    {
      title: "Badge",
      dataIndex: "Badge",
      sorter: (a, b) => a.Badge.length - b.Badge.length,
    },
    {
      title: "Employee ID",
      dataIndex: "CardId",
      sorter: (a, b) => a.CardId.length - b.CardId.length,
    },
    {
      title: "Name",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName.length - b.UserName.length,
    },
    {
      title: "DOJ",
      dataIndex: "DateOfJoining",
      sorter: (a, b) => new Date(a.DateOfJoining) - new Date(b.DateOfJoining),
      render: (text) => {
        return text ? dayjs(text).format("DD-MM-YYYY") : "-";
      },
    },
    {
      title: "Email",
      dataIndex: "EmailId",
      sorter: (a, b) => (a.EmailId || "").length - (b.EmailId || "").length,
      render: (text) => (text && text.trim() !== "" ? text : "-"),
    },
    // {
    //   title: "Status",
    //   dataIndex: "Status",
    //   render: (text) => (
    //     <span
    //       className={`badge ${
    //         text === "Present" ? "badge-success" : "badge-danger"
    //       } d-inline-flex align-items-center badge-xs`}
    //     >
    //       <i className="ti ti-point-filled me-1" />
    //       {text}
    //     </span>
    //   ),
    //   sorter: (a, b) => a.Status.length - b.Status.length,
    // },
    {
      title: "Designation",
      dataIndex: "Designation",
      sorter: (a, b) => a.Designation.length - b.Designation.length,
    },
  ];

  const generatePDF = () => {
    if (!teamMembers || teamMembers.length === 0) {
      return;
    }

    const formatDate = (dateString) => {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${date.getFullYear()}`;
    };

    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text("Employee Report", 14, 15);

    const tableColumn = [
      "Badge",
      "Employee ID",
      "Name",
      "DOJ",
      "Email",
      "Designation",
    ];

    const tableRows = teamMembers.map((item) => [
      item.Badge || "-",
      item.CardId || "-",
      item.UserName || "-",
      formatDate(item.DateOfJoining),
      item.EmailId?.trim() || "-",
      item.Designation || "-",
    ]);

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      margin: { bottom: 30 },
      didDrawPage: function () {
        doc.setFontSize(8);
        doc.setTextColor(150);

        const footerLeft = "2014-2025 © DreamsPOS. All Right Reserved";
        const footerRight = "Designed & Developed By Dreams";
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Left footer
        doc.text(footerLeft, 14, pageHeight - 10, { align: "left" });

        // Right footer
        doc.text(footerRight, pageWidth - 14, pageHeight - 10, {
          align: "right",
        });
      },
    });

    doc.save("Team Members.pdf");
  };

  const handleDownloadExcel = () => {
    if (!teamMembers || teamMembers.length === 0) return;

    const wsData = teamMembers.map((item, index) => ({
      "S.No": index + 1,
      Badge: item.Badge ?? "N/A",
      "Employee ID": item.CardId ?? "N/A",
      Name: item.UserName ?? "N/A",
      DOJ: item.DateOfJoining
        ? dayjs(item.DateOfJoining).format("DD-MM-YYYY")
        : "N/A",
      Email: item.EmailId?.trim() || "-",
      Designation: item.Designation ?? "N/A",
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Employee List");
    XLSX.writeFile(wb, "Employee_List.xlsx");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  return (
    <div>
      <div className="page-wrapper pt-5">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Team Members
                    </h4>
                  </ol>
                </nav>
                <h6>Your Team At Glance</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link onClick={generatePDF}>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    onClick={handleDownloadExcel}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={() => window.location.reload()}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            {/* <div className="page-btn mb-3"></div> */}
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set p-3"></div>
            </div>
            <div className="card-body pb-0">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : teamMembers.length > 0 ? (
                  <Table columns={columns} dataSource={teamMembers} />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
        <CommonFooter />
      </div>
    </div>
  );
};

export default TeamMembers;
